import {cookie} from '../modules/cookie';

class buyTicketsPopup {
	constructor(wrapper) {
        this._createElements(wrapper);
        this._addEvent();
	};

    _createElements(wrapper) {
        this.wrapper = wrapper;
        this.closeBtn = wrapper.querySelector('[data-close]');
        this.calendar = document.querySelector('.js-calendar');
        this.data = JSON.parse(this.wrapper.getAttribute('data-param'));
    };

    _gaStatErrorHandler(event){
        console.error('GA не сработал: ' + event + ' buyTicketsPopup')
    }

    _sendStatShow(){
        let self = this;
        try {
            // ga('send', 'event', 'pop-up', 'show', 'pop-up_buy-tickets-online_show', {nonInteraction: true});
            gtag('event', 'show', {
                'event_category': 'pop-up',
                'event_label': 'pop-up_buy-tickets-online_show',
                'non_interaction': true
            });
        } catch(e){
            self._gaStatErrorHandler('появление попапа');
        }
    }
    _sendStatBtnPress(){
        let self = this;
        try {
            // ga('send', 'event', 'pop-up', 'button-press', 'pop-up_buy-tickets-online_ok-button_press', {nonInteraction: false});

            gtag('event', 'button_press', {
                'event_category': 'pop-up',
                'event_label': 'pop-up_buy-tickets-online_ok-button_press'
            });

        } catch(e){
            self._gaStatErrorHandler('нажатие на кнопку «понятно»');
        }
    }

    _hide(){
        this.wrapper.classList.add("hidden");
        setTimeout(()=> {
            this._del();
        }, 500)
    }
    _show(){
        let self = this;
        this.wrapper.classList.remove("hidden");
        self._sendStatShow();
    }

    _close(){};

    _addEvent(){
        let self = this;

        let isShowed = false;

        this._close = function (e) {
            e.preventDefault();
            let cookieName = self.data.type.toLowerCase() + '_popup_buy_no';
            cookie.setCookie(cookieName, 1, {expires: 5.256e+6, path: '/'});
            self._sendStatBtnPress();
            self._hide();
        };

        this.closeBtn.addEventListener('click', this._close, false);

        if ( self.calendar ){
            window.addEventListener('scroll', function () {
                let rect = self.calendar.getBoundingClientRect();
                let scrollTop = document.documentElement.scrollTop ? document.documentElement.scrollTop : document.body.scrollTop;

                if ( scrollTop >= ( rect.top + 300 ) && !isShowed ) {
                    self._show();
                    isShowed = true;
                }
            }, false);
        } else {
            console.error('calendar element wasn`t find');
        }

    };

    _del(){
        this.closeBtn.removeEventListener('click', this._close, false);
        this.wrapper.parentNode.removeChild(this.wrapper);
    };

}

export {buyTicketsPopup};



